<div class="mat-typography">
    <router-outlet></router-outlet>
</div>
